import ApiClient from '@/plugins/api'
import ApiService from '@/plugins/apiService'

export default {
  state: {
    user: {
      email: '',
      token: ''
    },
    accInfo: {
      plan: {},
      payer: {},
      services: []
    },
    accessLinks: {}
  },

  mutations: {
    SET_USER_DATA (state, userData) {
      state.user = userData
      localStorage.setItem('user', JSON.stringify(userData))
      ApiClient.defaults.headers.common['Authorization'] = `Bearer ${
        userData.token
      }`
    },
    CLEAR_USER_DATA () {
      localStorage.removeItem('user')
      location.reload()
    },
    SET_ACCOUNT_INFO (state, info) {
      state.accInfo = info
    },
    SET_ACCESS_LINKS (state, links) {
      state.accessLinks = links
    }
  },

  actions: {
    register({ commit }, credentials) {
      return ApiService.register(credentials)
    },
    login({ commit }, credentials) {
      return ApiService.login(credentials)
        .then(({ data }) => {
          commit('SET_USER_DATA', data)
        })
    },
    activateAccount({ commit }, token) {
      return ApiService.activateAccount(token)
        .then(({ data }) => {
          commit('SET_USER_DATA', data)
        })
    },
    resetPassword({ commit }, email) {
      return ApiService.resetPassword(email)
    },
    logout({ commit }) {
      commit('CLEAR_USER_DATA')
    },
    setUserData({ commit }, data) {
      commit('SET_USER_DATA', data)
    },
    setAccInfo({ commit }) {
      return ApiService.getAccInfo()
        .then(({ data }) => {
          commit('SET_ACCOUNT_INFO', data)
        })
    },
    fetchAccessLinks({ commit }) {
      return ApiService.getAccessLinks()
        .then(({ data }) => {
          commit('SET_ACCESS_LINKS', data)
        })
    }
  },

  getters: {
    isAuthenticated (state) {
      return state.user && state.user.token
    }
  }
}
